<template>
  <v-container class="mt-2 mb-10">
    <div class="home-title">
      <div class="text-center">
        <h1>Tutoriales PATH</h1>
      </div>  
    </div>
    <div class="home-info">
      <div class="text-justify">
        <p>Bienvenido al sitio de <strong>"Tutoriales PATH"</strong>, aquí encontrarás cápsulas de menos de 5 minutos donde se explican los pasos que debes seguir para cumplir con tu responsabilidad como colaborador y supervisor, en cada etapa del proceso de Evaluación de Desempeño Anual.</p>
      </div>  
    </div>
    <div class="home-carousel">
      <v-carousel cycle>
        <v-carousel-item
          v-for="(sl, index) in slides"
          :key="'slide_'+sl.id"
          :src="sl.url_img"
          reverse-transition="fade-transition"
          transition="fade-transition"
        > 
          <v-container fill-height>
            <v-layout text-right>
              <v-flex>
                <div>
                  <span class="home-slide-titulo">{{sl.titulo}}</span>
                </div>
                <div v-if="sl.nom_video!=='NA'">
                  <span class="home-slide-video">
                    <a id="ac-slide" :href="sl.url_video">Ver video tutorial</a>
                  </span>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-carousel-item>
      </v-carousel>
    </div>
  </v-container>
</template>
<script>
  import { mapState } from 'vuex'
  export default {
    name: 'Home',
    computed: {
      ...mapState(['slides'])
    }
  }
</script>